<template>
	<v-container>
		<v-row>
			<v-col class="text-center" cols="12">
				<div class="headline primary--text">TeleRetina - Nationalities</div>
			</v-col>

			<v-col cols="12">
				<v-card>
					<v-card-title primary-title>
						Nationalities
						<v-spacer></v-spacer>
						<v-btn text icon color="primary" @click="dialog = true;">
							<v-icon>mdi-plus</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text class="pb-0">
						<v-data-table
							:headers="headers"
							:items="nationalities"
							hide-default-footer
							:loading="nationalities.length == 0"
							:items-per-page="-1"
						>
							<template v-slot:item.actions="{ item }">
								<span v-if="item.id" style="white-space: nowrap;">
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-icon color="primary" v-on="on" @click="showEditItem(item)">mdi-pen</v-icon>
										</template>

										<span>Edit</span>
									</v-tooltip>
								</span>
							</template>
						</v-data-table>
					</v-card-text>
					<v-card-actions v-if="length && false">
						<v-col cols="12" class="pa-0 text-center">
							<v-pagination
								v-model="nationalitiesPage"
								:length="length"
								:disabled="false"
								circle
								color="primary"
							></v-pagination>
						</v-col>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>

		<v-dialog v-model="dialog" persistent max-width="290">
			<v-card>
				<v-card-title class="headline">Add new language</v-card-title>
				<v-card-text>
					<v-text-field v-model="english" label="English" :rules="[rules.required]"></v-text-field>
					<v-text-field v-model="arabic" label="Arabic" :rules="[rules.required]"></v-text-field>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn class="text-none" color="error" text :disabled="loading" @click.native="dialog = false">
						<template>Close</template>
					</v-btn>
					<v-btn class="text-none" color="primary" :loading="loading" @click.native="addNewNationality">
						<template>Add</template>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="editItemModal" persistent max-width="290">
			<v-card>
				<v-card-title class="headline">Edit language</v-card-title>
				<v-card-text>
					<v-text-field v-model="editItemEnglish" label="English" :rules="[rules.required]"></v-text-field>
					<v-text-field v-model="editItemArabic" label="Arabic" :rules="[rules.required]"></v-text-field>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						class="text-none"
						color="error"
						text
						:disabled="loading"
						@click.native="editItemModal = false"
					>
						<template>Close</template>
					</v-btn>
					<v-btn class="text-none" color="primary" :loading="loading" @click.native="editNationality">
						<template>Edit</template>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
const axios = require("axios");

export default {
	mixins: [
		require("@/mixins/backend-mixin").default,
		require("@/mixins/router-mixin").default,
		require("@/mixins/rules-mixin").default
	],
	data() {
		return {
			headers: [
				{
					text: "#",
					align: "left",
					value: "id",
					sortable: false
				},
				{
					text: "English",
					align: "left",
					value: "description",
					sortable: false
				},
				{
					text: "Arabic",
					align: "left",
					value: "descriptionArabic",
					sortable: false
				},
				{
					text: "Actions",
					align: "center",
					value: "actions",
					sortable: false
				}
			],
			nationalities: [],
			nationalitiesPage: 1,
			length: 1,
			dialog: false,
			english: "",
			arabic: "",
			loading: false,
			editItemModal: false,
			editItemId: null,
			editItemEnglish: null,
			editItemArabic: null
		};
	},
	mounted() {
		this.getData();
	},
	methods: {
		getData() {
			this.getNationalities();
		},
		getNationalities() {
			const url = this.BACKEND_URL + "/api/allNationalities";
			const thisVue = this;

			axios
				.get(url)
				.then(response => {
					if (response.status == 200) {
						thisVue.nationalities = response.data;
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		addNewNationality() {
			this.loading = true;

			const url = this.BACKEND_URL + "/api/storeNationality";
			const thisVue = this;

			var data = {
				description: this.english,
				descriptionArabic: this.arabic
			};

			axios
				.post(url, data)
				.then(response => {
					console.log(response);

					thisVue.nationalities.push(data);

					thisVue.loading = false;
					thisVue.dialog = false;

					thisVue.$store.dispatch("triggerPushNotification", {
						message: "Nationality added."
					});
				})
				.catch(error => {
					console.error(error);
				});
		},
		showEditItem(item) {
			this.editItemModal = true;
			this.editItemId = item.id;
			this.editItemEnglish = item.description;
			this.editItemArabic = item.descriptionArabic;
		},
		editNationality() {
			this.loading = true;

			const url = this.BACKEND_URL + "/api/updateNationality";
			const thisVue = this;

			var data = {
				id: this.editItemId,
				description: this.editItemEnglish,
				descriptionArabic: this.editItemArabic
			};

			axios
				.post(url, data)
				.then(response => {
					console.log(response);

					var item = thisVue.nationalities.filter(
						item => item.id == thisVue.editItemId
					)[0];

					item.description = thisVue.editItemEnglish;
					item.descriptionArabic = thisVue.editItemArabic;

					thisVue.loading = false;
					thisVue.editItemModal = false;

					thisVue.$store.dispatch("triggerPushNotification", {
						message: "Nationality editted."
					});
				})
				.catch(error => {
					console.error(error);
				});
		}
	}
};
</script>